import { AppContext } from "contexts/AppContext";
import React, {
    useContext,
    useEffect,
    useState,
} from "react";
import { Modal } from "react-bootstrap";
import { callAPI } from "utils/API";
import ContentSmall from "components/elements/ContentSmall";
import ButtonMedium1 from "components/elements/ButtonMedium1";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import { translate } from "utils/Translate";
import { Box, OutlinedInput } from "@mui/material";
import CustomCheckbox from "components/elements/CustomCheckbox";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import WalletPaymentTerms from "modules/basket/WalletPaymentTerms";

const WalletPaymentModal = (props) => {
    const { brandData } = useContext(AppContext)
    const { show, setShow, amountPoints } = props
    const [selectedAmountPoints, setSelectedAmountPoints] = useState(amountPoints || 0);
    const [paymentSessionError, setPaymentSessionError] = useState(null)
    const [acceptTerms, setAcceptTerms] = useState(false)
    const [showPaymentTerms, setShowPaymentTerms] = useState(false)

    const startWalletPaymentSession = async (amountPoints) => {
        const originUrl = window.location.origin
        const paymentSessionResponse = await callAPI("payment/walletPaymentSession", "POST", { body: { callbackUrl: originUrl, amountPoints: amountPoints } })

        if (paymentSessionResponse && paymentSessionResponse.redirectUrl) {
            window.location.href = paymentSessionResponse.redirectUrl;
        } else {
            setPaymentSessionError(translate("_PROFILE_PAGE_PURCHASE_POINTS_ERROR_", "Der skete en fejl ved oprettelse af betalingssession. Prøv venligst igen senere."))
        }
    }

    useEffect(() => {
        setSelectedAmountPoints(props.amountPoints)
    }, [props.amountPoints])

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            onClick={e => e.stopPropagation()}
            style={{ zIndex: 2000 }}
            centered
        >
            <Modal.Header
                className="pb-0 border-0"
                closeButton
                style={{ fontSize: 9 }}
            >
                <Headline5
                    translationKey="_PROFILE_PAGE_PURCHASE_POINTS_MODAL_CAPTION_"
                    fallbackText="Køb point"
                />
            </Modal.Header>
            <Modal.Body className="pt-4 pb-4">
                <Box display={'flex'} flexDirection={'column'} gap={2} maxHeight={700} overflow={'auto'} paddingRight={2}>
                    <ContentNormal
                        translationKey="_PROFILE_PAGE_PURCHASE_POINTS_MODAL_DESCRIPTION_"
                        fallbackText="Vælg hvor mange point, du vil købe."
                    />

                    <Box display={'flex'} alignItems={'center'} gap={2}>
                        <OutlinedInput
                            type="number"
                            style={{
                                borderRadius: 14,
                                border: '1px solid #777',
                                height: 45,
                            }}
                            value={selectedAmountPoints}
                            onChange={(e) => setSelectedAmountPoints(e.target.value)}
                            onClick={e => e.stopPropagation()}
                        />

                        {!isNaN(selectedAmountPoints) && selectedAmountPoints > 0 && brandData?.brandPointRatio &&
                            <ContentSmall>
                                {translate("_Price_", "Pris")}: {Number((selectedAmountPoints / brandData?.brandPointRatio).toFixed(2)).toLocaleString("da-DK")} {translate("_DKK_", "kr.")}
                            </ContentSmall>
                        }
                    </Box>

                    <Box display={'flex'} paddingLeft={0.5} alignItems={'center'}>
                        <CustomCheckbox
                            checked={acceptTerms}
                            onChange={() => setAcceptTerms(!acceptTerms)}
                        />
                        <Box display={'flex'} alignItems={'center'} gap={0.5}>
                            <ContentSmall>
                                {translate("_PURCHASE_POINTS_ACCEPT_TERMS_", "Jeg accepterer ")}
                                <span
                                    style={{ cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => setShowPaymentTerms(!showPaymentTerms)}
                                >
                                    {translate("_TERMS_AND_CONDITIONS_", "handelsbetingelserne")}
                                </span>
                                *
                            </ContentSmall>
                        </Box>
                    </Box>

                    {showPaymentTerms &&
                        <WalletPaymentTerms />
                    }

                    {paymentSessionError && (
                        <ContentNormal style={{ color: 'red' }}>
                            {paymentSessionError}
                        </ContentNormal>
                    )}

                    <Box display={'flex'} justifyContent={'end'} gap={2}>
                        <ButtonMedium1
                            translationKey="_PROFILE_PAGE_PURCHASE_POINTS_MODAL_BUTTON_"
                            fallbackText="Gå til betaling"
                            onClick={(e) => {
                                e.stopPropagation();
                                startWalletPaymentSession(selectedAmountPoints);
                            }}
                            disabled={!acceptTerms || selectedAmountPoints <= 0 || !Number.isInteger(Number(selectedAmountPoints))}
                            showIcon={false}
                        />
                        <ButtonMedium4
                            translationKey="_CLOSE_"
                            fallbackText="Luk"
                            onClick={(e) => {
                                e.stopPropagation();
                                setShow(false);
                            }}
                            showIcon={false}
                        />
                    </Box>
                </Box>
            </Modal.Body>
        </Modal>
    );
};

export default WalletPaymentModal
